import { normalizePath } from '../../../../utils/path';

export async function execute(args, context) {
  const { dbRef, saveFile, onFileChanged } = context;
  const { path, content } = args;

  const normalizedPath = normalizePath(path);

  try {
    // Check file exists
    const existing = await dbRef.current.get('files', normalizedPath);
    if (!existing) {
      return {
        success: false,
        error: `File not found: ${normalizedPath}. Use create_file for new files.`
      };
    }

    // Save file
    await saveFile(normalizedPath, content);

    // Track changed files
    const changedFiles = JSON.parse(sessionStorage.getItem('changedFiles')) || [];
    if (!changedFiles.includes(normalizedPath)) {
      changedFiles.push(normalizedPath);
      sessionStorage.setItem('changedFiles', JSON.stringify(changedFiles));
    }

    // Notify about change
    if (onFileChanged) {
      await onFileChanged(normalizedPath, content);
    }

    const lines = content.split('\n').length;

    return {
      success: true,
      path: normalizedPath,
      size: content.length,
      lines,
      message: `File saved: ${normalizedPath} (${lines} lines, ${content.length} bytes)`
    };
  } catch (err) {
    return {
      success: false,
      error: `Failed to write file: ${err.message}`
    };
  }
}
